module.exports = __webpack_public_path__ + "img/723.6bdf1d8f.jpg";